import appraisalStore from "./appraisal/store";
import feedbackStore from "./feedback/store";
import reportStore from "./report/store";
import taskManagementStore from "./taskManagement/store";
import trainingStore from "./training/store";

export default {
  namespaced: true,
  modules: {
    appraisal: appraisalStore,
    feedback: feedbackStore,
    report: reportStore,
    task: taskManagementStore,
    training: trainingStore,
  },
};
